import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { notOnlyDigits, passwordRequirements, passwordsNotEqualToCurrent, usernameNotEqualToCurrent } from './digicode-herstel.validators';

@Injectable({ providedIn: 'root' })
export class DigicodeHerstelService {
    private static readonly MINIMUM_USERNAME_LENGTH = 6;
    private static readonly MAXIMUM_USERNAME_LENGTH = 24;

    public static getPasswordForm(): UntypedFormGroup {
        return new UntypedFormGroup({
            currentPassword: new UntypedFormControl('', {
                validators: [Validators.required]
            }),
            newPassword: new UntypedFormControl('', {
                validators: [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.maxLength(47),
                    passwordRequirements,
                    passwordsNotEqualToCurrent
                ]
            }),
            validatePassword: new UntypedFormControl('', {
                validators: [Validators.required]
            })
        });
    }

    public static getUsernameForm(): UntypedFormGroup {
        return new UntypedFormGroup({
            newUsername: new UntypedFormControl('', {
                validators: [
                    Validators.required,
                    Validators.minLength(this.MINIMUM_USERNAME_LENGTH),
                    Validators.maxLength(this.MAXIMUM_USERNAME_LENGTH),
                    notOnlyDigits,
                    usernameNotEqualToCurrent
                ]
            })
        });
    }
}
